module.exports = __webpack_public_path__ + "img/refresh.724b4827.png";